// Azure Static Web Apps built-in auth: read /.auth/me to get the current identity.
// Returns null if not signed in.

export type AppUser = {
  userId: string;
  userDetails: string;        // typically email
  identityProvider: string;   // 'aad' | 'github' | etc.
  userRoles: string[];        // 'anonymous' | 'authenticated' | custom roles
};

type SwaAuthResponse = { clientPrincipal: AppUser | null };

export async function getCurrentUser(): Promise<AppUser | null> {
  try {
    const res = await fetch("/.auth/me");
    if (!res.ok) return null;
    const data = (await res.json()) as SwaAuthResponse;
    return data.clientPrincipal;
  } catch {
    return null;
  }
}

export function loginUrl(redirect: string = window.location.pathname): string {
  return `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(redirect)}`;
}

export function logoutUrl(): string {
  return "/.auth/logout";
}
